import { BaseComponent } from '../../../components/BaseComponent';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { updateCompanyProperties } from '../actions';
import { fetchInvoice } from '../../Invoices/actions';
import { Loader } from '../../../components/Loader';
import { Dropdown } from '../../../components/Dropdown';
import { Button } from '../../../components/Buttons';
import { HBox } from '../../../components/Box';
import { Input } from '../../../components/Input';
import { FormField } from '../../../components/FormFields';
import { getPropByName } from '../../../utils/props';
import { Permission } from '../../../components/Permission';
import { EDIT_COMPANY_STATUS } from '../../../components/Permission/constants';
import { setCompanyProperty } from '../actions';
import { formatedDateNow, getDaysBetweenDates } from '../helpers';
import { selectConfig } from '../../Api/selectors';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styles from './StatusLabel.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

dayjs.extend(customParseFormat);

const Container = styled.div``;

const Label = styled.p`
  padding: 2px;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background-color: ${props => {
    if (props.status == '0' || props.status == 'Actief') {
      return '#D50046';
    }
    if (props.status == '1') {
      return 'rgb(21, 172, 121)';
    }
    if (props.status == '2') {
      return 'orange';
    }
    if (props.status == '3') {
      return 'darkviolet';
    }
    if (props.status == '4') {
      return 'black';
    }
    if (props.status == '5') {
      return '#FF0000';
    }
  }};
`;

const STATE = {
  edit: false,
  status_remark: '',
};

class StatusCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.setStatusLogs && this.props.company?.status_remark) {
      this.setState({ status_remark: this.props.company?.status_remark, selected: this.props.status });
    }
  }

  get options() {
    return _.times(6).map(value => ({ label: this.lbl(`company.property.status.${value || 0}`), value: `${value}` }));
  }

  get selected() {
    return this.options.find(o => o.value == this.state.selected);
  }

  onChange(v) {
    this.setState({ selected: v.value });
  }

  save() {
    this.setState({ loading: true });
    if (this.props.onChangeStatus) {
      this.props.onChangeStatus(this.state.selected);
      return this.setState({ loading: false, edit: false });
    }
    if (
      this.props.status != '1' &&
      this.state.selected == '1' &&
      this.props.config.addClientId === WIENTJES_INSTALATION.APP_CLIENT_ID
    ) {
      this.props.setProperty('put_on_approved_date', formatedDateNow(), result => {});
    }

    if (this.props.setStatusLogs) {
      this.props.onChangeWithLogs(this.state.selected, this.props.loggedInUserId, this.state.status_remark, result => {
        this.setState({ loading: false, status_remark: '', edit: false });
      });
      return;
    }
    this.props.onChange(this.state.selected, result => {
      if (this.props.invoiceId) {
        this.props.fetchInvoice(this.props.invoiceId);
      }
      this.setState({
        loading: false,
        edit: false,
      });
    });
  }

  render() {
    return (
      <Container>
        <HBox vCenter left className={styles.status}>
          <Label status={this.props.status} onClick={!this.props.withoutEdit ? this.setStateFn({ edit: true }) : () => {}}>
            {this.props.children}
          </Label>
          <Permission permission={EDIT_COMPANY_STATUS}>
            {!!this.state.edit && (
              <>
                <div className={styles.container}>
                  <Dropdown
                    className={styles.dropdown}
                    options={this.options}
                    value={this.selected}
                    onChange={this.onChange.bind(this)}
                  />
                </div>

                <ButtonComponent style="ButtonSoftPrimary" size="btn-sm" onClick={this.save.bind(this)}>
                  {this.lbl('save')}
                </ButtonComponent>
              </>
            )}
          </Permission>
          {this.state.loading ? <Loader small /> : null}
        </HBox>
        <Permission permission={EDIT_COMPANY_STATUS}>
          {!!this.state.edit && !!this.props.setStatusLogs && (
            <FormField label={'status_remark'}>
              <Input value={this.state.status_remark} onChange={e => this.setState({ status_remark: e.target.value })} />
            </FormField>
          )}
        </Permission>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    onChangeWithLogs(status, user, info = '', callback) {
      dispatch(
        updateCompanyProperties(
          ownProps.company.id,
          [
            { name: 'status', value: status },
            { name: 'user_changed_status', value: user },
            { name: 'status_remark', value: info || ' ' },
          ],
          ownProps.company.addresses,
          null,
          callback,
        ),
      );
    },
    onChange(status, callback) {
      dispatch(
        updateCompanyProperties(
          ownProps.company.id,
          [{ name: 'status', value: status }],
          ownProps.company.addresses,
          null,
          callback,
        ),
      );
    },
    setProperty(propertyName, propertyValue, callback) {
      dispatch(setCompanyProperty(ownProps.company.id, propertyName, propertyValue, callback));
    },
    fetchInvoice() {
      dispatch(fetchInvoice(ownProps?.invoiceId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyStatusCard = compose(withConnect, withRouter)(StatusCardComp);
